import { CurrencyrateListUrlSortField } from "@saleor/currencyrate/urls";
import { CurrencyrateSortField } from "@saleor/types/globalTypes";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryField(
  sort: CurrencyrateListUrlSortField
): CurrencyrateSortField {
  switch (sort) {
    case CurrencyrateListUrlSortField.name:
      return CurrencyrateSortField.NAME;
    case CurrencyrateListUrlSortField.onlineRate:
      return CurrencyrateSortField.ONLINE_RATE;
    case CurrencyrateListUrlSortField.rate:
      return CurrencyrateSortField.RATE;
    case CurrencyrateListUrlSortField.slug:
      return CurrencyrateSortField.SLUG;
    case CurrencyrateListUrlSortField.symbol:
      return CurrencyrateSortField.SYMBOL;
    case CurrencyrateListUrlSortField.updateDate:
      return CurrencyrateSortField.UPDATE_DATE;
  }
}
export const getSortQueryVariables = createGetSortQueryVariables(
  getSortQueryField
);
